import React from "react"
import Modal from "../shared/Modal"
import useResourceList from "../../hooks/useResourceList"

const ResourceListModal = ({
  title,
  endpoint,
  listKey,
  itemKey,
  emptyText,
  loadingText,
  renderMeta,
  onLoad,
  onClose,
}) => {
  const { items, loading, error, deletingId, loadingId, deleteItem, loadItem, isItemBusy } = useResourceList(
    endpoint,
    listKey,
    itemKey
  )

  const handleLoad = async (id) => {
    const item = await loadItem(id)
    if (item) {
      onLoad(item)
      onClose()
    }
  }

  return (
    <Modal title={title} onClose={onClose}>
      {error && <div className="error-message modal-error">{error}</div>}

      {loading ? (
        <div className="modal-loading">{loadingText}</div>
      ) : items.length === 0 ? (
        <div className="wheel-list-empty">{emptyText}</div>
      ) : (
        <div className="wheel-list">
          {items.map((item) => (
            <div key={item.id} className="wheel-list-item">
              <div className="wheel-list-item-info">
                <div className="wheel-list-item-name">{item.name}</div>
                <div className="wheel-list-item-meta">{renderMeta(item)}</div>
              </div>
              <div className="wheel-list-item-actions">
                <button
                  className="wheel-list-item-btn wheel-list-item-btn-load"
                  onClick={() => handleLoad(item.id)}
                  disabled={isItemBusy(item.id)}
                  title={`Load this ${itemKey}`}
                >
                  {loadingId === item.id ? "..." : "Load"}
                </button>
                <button
                  className="wheel-list-item-btn wheel-list-item-btn-delete"
                  onClick={() => deleteItem(item.id, item.name)}
                  disabled={isItemBusy(item.id)}
                  title={`Delete this ${itemKey}`}
                >
                  {deletingId === item.id ? "..." : "Delete"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Modal>
  )
}

export default ResourceListModal
